<template>
  <CommonLayout header="ManagementHeader" footer="ManagementFooter">
    <b-overlay :show="overlayShow" rounded="sm">
      <div class="container">
        <div class="main-color text-light row mt-3">
          <div class="col p-2">
            <a id="projectList" class="ml-1 list-type" @click="changeListType('projectList')">制作案件一覧</a>
            <a id="dataList" class="ml-1 list-type" @click="changeListType('dataList')">発注データ作成</a>
            <a id="orderList" class="ml-1 list-type active-list">発注履歴</a>
          </div>
        </div>

        <!-- 案件制作一覧リスト -->
        <div id="search-list" class="row base-color mt-3 py-4">
          <div class="col-sm-12 mt-3">
            <b-table-simple bordered class="small">
              <thead role="rowgroup" class="table-bordered">
                <tr role="row" class="align-middle" v-if="isFrenet">
                  <th class="align-middle text-center" style="width: 25%;">制作拠点コード</th>
                  <th class="align-middle text-center" style="width: 25%;">制作拠点名</th>
                  <th class="align-middle text-center" style="width: 25%;">発注日時</th>
                  <th class="align-middle text-center" style="width: 25%;">フレネット<br>連携実施結果</th>
                </tr>
                <tr role="row" class="align-middle" v-else>
                  <th class="align-middle text-center" style="width: 33%;">制作拠点コード</th>
                  <th class="align-middle text-center" style="width: 33%;">制作拠点名</th>
                  <th class="align-middle text-center" style="width: 33%;">発注日時</th>
                </tr>
              </thead>
              <tbody class="white-line" v-if="order">
                <tr v-if="isFrenet">
                  <td class="align-middle">{{order['制作拠点コード']['value']}}</td>
                  <td class="align-middle">{{order['制作拠点名']['value']}}</td>
                  <td class="align-middle">{{formatDate(order['発注日時']['value'])}}</td>
                  <td class="align-middle">{{order['フレネット連携実施結果']['value']}}</td>
                </tr>
                <tr v-else>
                  <td class="align-middle">{{order['制作拠点コード']['value']}}</td>
                  <td class="align-middle">{{order['制作拠点名']['value']}}</td>
                  <td class="align-middle">{{formatDate(order['発注日時']['value'])}}</td>
                </tr>
              </tbody>
            </b-table-simple>
          </div>

          <div class="col-sm-12" v-if="order">
            <b-table-simple bordered class="small">
              <thead role="rowgroup" class="table-bordered">
                <tr role="row" class="align-middle">
                  <th class="align-middle text-center">商材コード1</th>
                  <th class="align-middle text-center">商材コード2</th>
                  <th class="align-middle text-center" style="width:23%">商材名</th>
                  <th class="align-middle text-center">規格</th>
                  <th class="align-middle text-center" style="width:10%">色</th>
                  <th class="align-middle text-center" v-if="isFrenet">顧客コード</th>
                  <th class="align-middle text-center">本数</th>
                  <th class="align-middle text-center">納品日</th>
                  <th class="align-middle text-center">ロット</th>
                  <th class="align-middle text-center">ロット割れ</th>
                  <th class="align-middle text-center">売上区分</th>
                </tr>
              </thead>
              <b-tbody v-if="isFrenet">
                <b-tr v-for="(row, index) in order['CSVデータ']['value']" :key="index + 'csvrow'" :class="index % 2 === 1 ? 'gray-line' : 'white-line'">
                  <td class="align-middle">{{row['value']['品目コード']['value']}}</td>
                  <td class="align-middle">{{row['value']['品種コード']['value']}}</td>
                  <td class="align-middle">{{row['value']['形状']['value']}}</td>
                  <td class="align-middle">{{formatKikaku(row['value']['等階級コード1']['value'])}}</td>
                  <td class="align-middle">{{row['value']['色']['value']}}</td>
                  <td class="align-middle">{{row['value']['顧客コード']['value']}}</td>
                  <td class="align-middle">{{row['value']['受注量']['value']}}</td>
                  <td class="align-middle">{{formatDeliveryDate(row['value']['納品日']['value'])}}</td>
                  <td class="align-middle">{{row['value']['ロット']['value']}}</td>
                  <td class="align-middle">{{row['value']['数量_初期値']['value'] ? row['value']['受注量']['value'] ? parseFloat(Math.round(row['value']['受注量']['value'] * 100 - row['value']['数量_初期値']['value'] * 100)/100) : '' : ''}}</td>
                  <td class="align-middle">{{row['value']['用途コード']['value']}}</td>
                </b-tr>
              </b-tbody>
              <b-tbody v-else>
                <b-tr  v-for="(row, index) in order['CSVデータ']['value']" :key="index + 'csvrow'" :class="index % 2 === 1 ? 'gray-line' : 'white-line'">
                  <td class="align-middle">{{row['value']['品目コード']['value']}}</td>
                  <td class="align-middle">{{row['value']['品種コード']['value']}}</td>
                  <td class="align-middle">{{row['value']['商材名']['value']}}</td>
                  <td class="align-middle">{{row['value']['規格']['value']}}</td>
                  <td class="align-middle">{{row['value']['色']['value']}}</td>
                  <td class="align-middle">{{row['value']['数量']['value']}}</td>
                  <td class="align-middle">{{formatDeliveryDate(row['value']['納品日']['value'])}}</td>
                  <td class="align-middle">{{row['value']['ロット']['value']}}</td>
                  <td class="align-middle">{{row['value']['数量']['value'] ? row['value']['受注量']['value'] ? parseFloat(Math.round(row['value']['受注量']['value'] * 100 - row['value']['数量']['value'] * 100)/100) : '' : ''}}</td>
                  <td class="align-middle">{{row['value']['用途コード']['value']}}</td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>

          <div class="col-sm-12">
            <b-button variant="primary" @click="pageBack()">戻る</b-button>
          </div>
        </div>

      </div>
    </b-overlay>
  </CommonLayout>
</template>

<script>
import CommonLayout from '@/layout/CommonLayout'
import OrderDetailModel from '@/models/OrderDetailModel'

export default {
  name: 'OrderDetail',
  components: {
    CommonLayout
  },
  data () {
    return {
      overlayShow: false,
      orderNo: 0,
      isFrenet: 0,
      order: null
    }
  },
  methods: {
    setOrderData () {
      this.overlayShow = true
      const reqData = {
        'order_no': this.orderNo,
        'is_frenet': this.isFrenet
      }
      OrderDetailModel.getApi(this.$bvModal, reqData, (data) => {
        this.order = data.order
      }, () => {
        this.overlayShow = false
      })
    },
    formatDate (date) {
      // 日付のフォーマット
      const newDate = new Date(date)
      const weekday = ['日', '月', '火', '水', '木', '金', '土']
      let format = 'YYYY/MM/DD(WW) hh:mm'
      format = format.replace(/YYYY/g, newDate.getFullYear())
      format = format.replace(/MM/g, ('0' + (newDate.getMonth() + 1)).slice(-2))
      format = format.replace(/DD/g, ('0' + newDate.getDate()).slice(-2))
      format = format.replace(/WW/g, weekday[newDate.getDay()])
      format = format.replace(/hh/g, ('0' + newDate.getHours()).slice(-2))
      format = format.replace(/mm/g, ('0' + newDate.getMinutes()).slice(-2))
      return format
    },
    formatDeliveryDate (date) {
      // 納品日のフォーマット
      const newDate = new Date(date)
      const weekday = ['日', '月', '火', '水', '木', '金', '土']
      let format = 'YYYY/MM/DD(WW)'
      format = format.replace(/YYYY/g, newDate.getFullYear())
      format = format.replace(/MM/g, ('0' + (newDate.getMonth() + 1)).slice(-2))
      format = format.replace(/DD/g, ('0' + newDate.getDate()).slice(-2))
      format = format.replace(/WW/g, weekday[newDate.getDay()])
      return format
    },
    formatKikaku (value) {
      switch (value) {
        case '42':
          return '2L'
        case '41':
          return 'L'
        case '31':
          return 'M'
        case '21':
          return 'S'
        default:
          return ''
      }
    },
    changeListType (target) {
      if (target === 'dataList') {
        this.$router.push('/project_list?list_type=dataList')
      } else {
        this.$router.push('/project_list?list_type=projectList')
      }
    },
    pageBack () {
      localStorage.setItem('isOrderPageBack', JSON.stringify(true))
      this.$router.push('/order_list')
    }
  },
  computed: {
  },
  watch: {
  },
  mounted () {
    this.orderNo = this.$route.params.orderNo
    this.isFrenet = Number(this.$route.query.is_frenet)
    this.setOrderData()
  }
}
</script>

<style scoped>
table > thead > tr > th {
  background-color: #161C3D !important;
  border: 1px solid #dee2e6 !important;
  color: #fefefe;
  font-weight: normal;
}
.active-list {
  background-color: #CACFEC;
  color: rgb(22, 28, 61);
}
.list-type {
  padding: 0.5rem;
  color: #fefefe;
}
.list-type:hover {
  color: #fefefe;
  cursor: pointer;
}
.active-list {
  background-color: #CACFEC;
  color: rgb(22, 28, 61);
}
.active-list:hover {
  background-color: #CACFEC;
  color: rgb(22, 28, 61);
  cursor: default;
  text-decoration: none;
}
table {
  border-collapse: separate;
  border-spacing: 0px;
}
thead {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 1;
}
th, td {
  padding: 0px 8px !important;
}
.white-line {
background-color: #fff;
}
.white-line:hover {
background-color: #d9efff !important;
}
.gray-line {
background-color: #eefdff;
}
.gray-line:hover {
background-color: #d9efff !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/OrderDetail.vue